import React, { useEffect, useRef } from "react";
import { Box, Stack } from "@mui/joy";
import { theme } from "styles/theme";
import CustomTypography from "components/common/CustomTypography";
import { useNavigate } from "react-router-dom";
import coffee_bigger_than from "static/image/onboarding/coffee_bigger_than.png";
import distancing_bigger_than from "static/image/onboarding/distancing_bigger_than.png";
import { BottomNextButtonTmp } from "../../../../components/common/BottomNextButtonTmp";
import {
  MktVersionTypes,
  versionToPathPrefix,
} from "../../../../components/mkt/mktVersionUtils";
import { useRecoilValue } from "recoil";
import { webTestTypeAtom } from "../../../../recoil/webTestTypeAtom";

export default function Habit_7_Promotion({
  version = "v4",
}: {
  version?: MktVersionTypes;
}) {
  const navigate = useNavigate();
  const webTestType = useRecoilValue(webTestTypeAtom);
  const isTherapyPromotion =
    version === "v4" && webTestType?.onboardingType === "h";

  const handleNext = () => {
    navigate(`/${versionToPathPrefix(version)}-onboarding/motivation/1`, {
      replace: true,
    });
  };

  const pageKey = "habit_7";

  function useEffectOnce(callback: () => void) {
    const ref = useRef(false);

    useEffect(() => {
      if (ref.current) return;
      ref.current = true;

      if (typeof callback === "function") {
        callback();
      }
    }, []);
  }

  useEffectOnce(() => {});

  return (
    <Box sx={{ paddingBottom: "150px" }}>
      <Stack spacing={4}>
        <Stack spacing={2}>
          <CustomTypography
            variant="Subtitle"
            fontWeight={700}
            sx={{
              color: theme.vars.palette.Content.Highlight,
            }}
          >
            {"내 삶의 변화를 위한 값진 투자."}
          </CustomTypography>
          {!isTherapyPromotion && (
            <CustomTypography
              variant="Subtitle"
              fontWeight={500}
              sx={{
                color: theme.vars.palette.Content.Strong,
              }}
            >
              {
                "프리미엄 코칭이 제공되는 최상위 마스터 플랜 기준으로도 하루 이용 비용은 4천 원대. 커피 한 잔 가격에 불과합니다."
              }
            </CustomTypography>
          )}
          <CustomTypography
            variant="Subtitle"
            fontWeight={500}
            sx={{
              color: theme.vars.palette.Content.Strong,
            }}
          >
            {isTherapyPromotion
              ? "당신이 디스턴싱에 투자할 100일은 앞으로 살아갈 50년 중 1%도 채 되지 않습니다."
              : "그리고 당신이 디스턴싱에 투자할 100일은 앞으로 살아갈 50년 중 1%도 채 되지 않습니다."}
          </CustomTypography>
          <CustomTypography
            variant="Subtitle"
            fontWeight={500}
            sx={{
              color: theme.vars.palette.Content.Strong,
            }}
          >
            {"단 1%의 시간으로 남은 99%의 삶을 바꿔보세요."}
          </CustomTypography>
        </Stack>

        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={isTherapyPromotion ? distancing_bigger_than : coffee_bigger_than}
            alt={"onboarding"}
            style={{
              width: "90%",
              maxWidth: "330px",
              objectFit: "contain",
            }}
          />
        </Box>
      </Stack>
      <BottomNextButtonTmp
        disabled={false}
        onClick={handleNext}
        text={"다음"}
        highlightBackground={true}
      />
    </Box>
  );
}
